module.exports = __webpack_public_path__ + "img/cyril.2b51e2f1.jpeg";